document.addEventListener("DOMContentLoaded", () => {
  const preOrderForm = document.querySelector("#pre-order-form");
  if (!preOrderForm) return;

  const getRadios = () =>
    document.querySelectorAll(".pre_order_variant_container input[type='radio']");

  const clean = (value) => String(value || "").trim().toLowerCase();

  // Find the pre-order variant that matches the selected main variant.
  // 1) exact title match, 2) every option of the pre-order variant is in the main variant's options
  const findMatch = (variant) => {
    if (!variant) return null;

    const mainTitle = clean(variant.title);
    const mainOptions = (variant.options || []).map(clean);
    const radios = Array.from(getRadios());

    const exact = radios.find((radio) => clean(radio.dataset.title) === mainTitle);
    if (exact) return exact;

    return (
      radios.find((radio) => {
        const preOptions = clean(radio.dataset.title).split(" / ").map(clean);
        return preOptions.length > 0 && preOptions.every((opt) => mainOptions.includes(opt));
      }) || null
    );
  };

  const selectPreOrder = (variant) => {
    const match = findMatch(variant);

    getRadios().forEach((radio) => {
      radio.checked = false;
    });

    if (!match) {
      preOrderForm.classList.add("hide__form");
      return;
    }

    match.checked = true;

    if (match.classList.contains("hide__pre_order")) {
      preOrderForm.classList.add("hide__form");
    } else {
      preOrderForm.classList.remove("hide__form");
    }
  };

  // When the customer changes size or colour
  document.addEventListener("variant:change", (event) => {
    const variant = event.detail && event.detail.variant;
    if (variant) selectPreOrder(variant);
  });

  // On page load
  let initialVariant = null;
  const variantData = document.querySelector("variant-picker script[data-variant]");

  if (variantData) {
    try {
      initialVariant = JSON.parse(variantData.textContent);
    } catch (error) {
      initialVariant = null;
    }
  }

  if (!initialVariant && window.product && window.product.variants) {
    const checkedLabels = Array.from(
      document.querySelectorAll("variant-picker input[type='radio']:checked")
    ).map((input) => (input.nextElementSibling ? input.nextElementSibling.textContent.trim() : ""));

    initialVariant =
      window.product.variants.find((variant) =>
        variant.options.every((opt, index) => checkedLabels[index] === opt)
      ) || null;
  }

  if (initialVariant) selectPreOrder(initialVariant);
});